import type { PageBehaviorContext } from '@teo/widget-shared';
import { clearLastPointerPosition } from './pointer-state.js';

let snapshot: PageBehaviorContext = {
  maxScrollDepthPercent: 0,
  timeOnPageMs: 0,
};

let pageEnteredAt = Date.now();

export function resetPageBehaviorState(): void {
  pageEnteredAt = Date.now();
  clearLastPointerPosition();
  snapshot = {
    maxScrollDepthPercent: 0,
    timeOnPageMs: 0,
  };
}

export function patchPageBehaviorState(
  patch: Partial<PageBehaviorContext>,
): void {
  snapshot = {
    ...snapshot,
    ...patch,
    timeOnPageMs: Date.now() - pageEnteredAt,
  };
}

export function getPageBehaviorSnapshot(): PageBehaviorContext {
  return {
    ...snapshot,
    timeOnPageMs: Date.now() - pageEnteredAt,
    focusedProduct: snapshot.focusedProduct
      ? { ...snapshot.focusedProduct }
      : undefined,
  };
}
